import { render } from "./AnnotationEditorHistoryDrawer.vue?vue&type=template&id=65d3e37e&scoped=true"
import script from "./AnnotationEditorHistoryDrawer.vue?vue&type=script&lang=js"
export * from "./AnnotationEditorHistoryDrawer.vue?vue&type=script&lang=js"

import "./AnnotationEditorHistoryDrawer.vue?vue&type=style&index=0&id=65d3e37e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d3e37e"]])

export default __exports__